import i18next from "i18next";

const documentation = {
    "camera-not-showing+ios":
        "https://checkventory.atlassian.net/wiki/spaces/PF/pages/28278785/iPhone+Location+Camera+permissions",
    "location-error+ios":
        "https://checkventory.atlassian.net/wiki/spaces/PF/pages/28278785/iPhone+Location+Camera+permissions",
    "camera-not-showing+android":
        "https://checkventory.atlassian.net/wiki/spaces/PF/pages/24936449/Android+Location+Camera+Permissions",
    "location-error+android":
        "https://checkventory.atlassian.net/wiki/spaces/PF/pages/24936449/Android+Location+Camera+Permissions",
};

const content = {
    problems: {
        description: i18next.t("messages.indicateProblem"),
        entries: [
            {
                code: "camera-not-showing",
                label: i18next.t("messages.cameraIsNotShowing"),
            },
            {
                code: "location-error",
                label: i18next.t("messages.gettingLocationError"),
            },
        ],
    },
    "device-os": {
        description: i18next.t("messages.selectOS"),
        entries: [
            {
                code: "ios",
                label: "iOS",
            },
            {
                code: "android",
                label: "Android",
            },
        ],
    },
};

export { documentation, content };
